<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :actions="actions"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :beforeSetupGrid="beforeSetupGrid"
            ref="grid"
        ></dx-grid>
        <v-dialog persistent v-model="updateTeacherDialog" max-width="500">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Update Settings - {{ rowClicked.teacherH }}</v-card-title
                >
                <v-layout row class="mb-3 ma-0 pa-0" v-if="!isContact()">
                    <v-btn
                        v-if="rowClicked.teacherNameRecording"
                        @click="rowClicked.teacherNameRecording = null"
                        flat
                        class="mr-2"
                        icon
                        color="red"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <audio
                        class="mr-3"
                        v-if="rowClicked.teacherNameRecording"
                        controls
                        :src="rowClicked.teacherNameRecording"
                    ></audio>
                    <v-btn
                        small
                        outline
                        class="mr-2"
                        :loading="uploading"
                        @click="pickFile()"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <input
                        type="file"
                        style="display: none"
                        ref="files"
                        accept=".mp3"
                        @change="onFilePicked($event, false)"
                    />
                </v-layout>
                <v-text-field
                    class="mx-2"
                    v-model="rowClicked.alertPhone"
                    :label="isContact() ? 'Phone Number' : 'Alert Phone Number'"
                    ref="alertPhone"
                    :rules="[rules.phoneNumber, rules.required]"
                ></v-text-field>
                <v-text-field
                    v-if="!isContact()"
                    class="mx-2"
                    v-model="rowClicked.pinNumber"
                    label="Pin Number"
                    ref="pinNumber"
                    :rules="[rules.pinNumber]"
                ></v-text-field>
                <v-text-field
                    class="mx-2"
                    v-model="rowClicked.busNumber"
                    label="Bus Number"
                    v-if="rowClicked.type == 'BUS_DRIVER'"
                    ref="busNumber"
                ></v-text-field>
                <v-layout class="pa-0">
                    <v-text-field
                        class="mx-2 pt-1"
                        v-model="rowClicked.name"
                        label="Name"
                    ></v-text-field>
                    <v-btn
                        v-if="!isContact() && !isBusDriver()"
                        class="mb-0 pt-1"
                        :disabled="!rowClicked.name"
                        @click="playText(rowClicked.name)"
                        flat
                        icon
                        color="info"
                    >
                        <v-icon>mdi-play-circle</v-icon>
                    </v-btn>
                </v-layout>
                <v-layout class="pa-0">
                    <v-text-field
                        class="mx-2 pt-1"
                        v-model="rowClicked.nameH"
                        label="Hebrew Name"
                    ></v-text-field>
                </v-layout>
                <v-select
                    v-if="!isContact() && !isBusDriver()"
                    class="mx-2"
                    v-model="rowClicked.connectionMode"
                    label="Connection Mode"
                    ref="connectionMode"
                    :items="['LIVE', 'MESSAGE']"
                ></v-select>
                <v-select
                    v-if="isContact() && isBusDriver()"
                    class="mx-2"
                    v-model="rowClicked.branch"
                    label="Branch"
                    ref="branch"
                    multiple
                    :items="branchList"
                ></v-select>
                <v-menu
                    v-if="!isContact()"
                    ref="alertTime"
                    v-model="timePickerMenu"
                    :close-on-content-click="false"
                    :return-value.sync="rowClicked.alertTime"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="rowClicked.alertTime"
                            label="Alert Time"
                            class="mx-2"
                            readonly
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-time-picker
                        v-model="rowClicked.alertTime"
                        @input="saveAlertTime($event)"
                    ></v-time-picker>
                </v-menu>
                <v-switch
                    v-if="!isContact() && !isBusDriver()"
                    color="success"
                    class="mt-0"
                    v-model="rowClicked.allowBroadcast"
                    label="Allow Broadcast"
                    hide-details
                ></v-switch>
                <v-switch
                    v-if="!isContact() && !isBusDriver()"
                    color="success"
                    class="my-3"
                    hide-details
                    v-model="rowClicked.allowChargeCC"
                    label="Allow Charge Credit Card (Tip)"
                ></v-switch>
                <v-switch
                    v-if="!isContact() && !isBusDriver()"
                    color="success"
                    class="my-3"
                    hide-details
                    v-model="rowClicked.disabled"
                    label="Disabled"
                ></v-switch>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="updateTeacherDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="warning"
                        dark
                        v-if="isContact() || isBusDriver()"
                        :disabled="deletingTeacher"
                        @click="deleteTeacherConfirmationDialog = true"
                        >Delete</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="save()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="addNewTeacherDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >New Contact</v-card-title
                >
                <v-layout
                    row
                    class="mb-3 ma-0 pa-0"
                    v-if="newTeacher.type == 'BUS_DRIVER'"
                >
                    <v-btn
                        v-if="newTeacher.teacherNameRecording"
                        @click="newTeacher.teacherNameRecording = null"
                        flat
                        class="mr-2"
                        icon
                        color="red"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <audio
                        class="mr-3"
                        v-if="newTeacher.teacherNameRecording"
                        controls
                        :src="newTeacher.teacherNameRecording"
                    ></audio>
                    <v-btn
                        small
                        outline
                        class="mr-2"
                        :loading="uploading"
                        @click="pickFile(true)"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <input
                        type="file"
                        style="display: none"
                        ref="newTeacherFiles"
                        accept=".mp3"
                        @change="onFilePicked($event, true)"
                    />
                </v-layout>
                <v-text-field
                    class="mx-2"
                    v-model="newTeacher.alertPhone"
                    :label="
                        newTeacher.type == 'CONTACTS'
                            ? 'Phone Number'
                            : 'Alert Phone Number'
                    "
                    ref="newAlertPhone"
                    :rules="[rules.phoneNumber, rules.required]"
                ></v-text-field>
                <v-text-field
                    class="mx-2"
                    v-if="newTeacher.type == 'BUS_DRIVER'"
                    v-model="newTeacher.busNumber"
                    label="Bus Number"
                    ref="busNumber"
                    :rules="[rules.required]"
                ></v-text-field>
                <v-select
                    class="mx-2"
                    :disabled="newTeacher.type == 'BUS_DRIVER'"
                    v-model="newTeacher.branch"
                    label="Branch"
                    multiple
                    :items="branchList"
                ></v-select>
                <v-layout class="pa-0">
                    <v-text-field
                        class="mx-2 pt-1"
                        v-model="newTeacher.name"
                        label="Name"
                        ref="newName"
                        :rules="[rules.required]"
                    ></v-text-field>
                    <!-- <v-btn
                        class="mb-0 pt-1"
                        :disabled="!newTeacher.name"
                        @click="playText(newTeacher.name)"
                        flat
                        icon
                        color="info"
                    >
                        <v-icon>mdi-play-circle</v-icon>
                    </v-btn> -->
                </v-layout>
                <v-layout class="pa-0">
                    <v-text-field
                        class="mx-2 pt-1"
                        v-model="newTeacher.nameH"
                        label="Hebrew Name"
                        ref="newNameH"
                        :rules="[rules.required]"
                    ></v-text-field>
                </v-layout>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="addNewTeacherDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveNewTeacher()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="deleteTeacherConfirmationDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline text-danger"
                    >Are You Sure?</v-card-title
                >
                <v-card-text class="pt-0"
                    >This will delete:
                    <div class="font-weight-medium">
                        {{
                            rowClicked.nameH
                                ? rowClicked.nameH
                                : rowClicked.name
                        }}
                    </div></v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteTeacherConfirmationDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="deletingTeacher"
                        @click="deleteTeacher"
                        >Delete</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import moment from "moment";
import AWS from "aws-sdk";

export default {
    data: () => ({
        title: "Teacher Settings",

        actions: [],

        updateTeacherDialog: false,
        timePickerMenu: false,

        rowClicked: {
            teacherCode: "",
            teacherNameRecording: "",
            alertPhone: "",
            connectionMode: "",
            pinNumber: "",
            alertTime: "",
            type: "",
            allowBroadcast: "",
            allowChargeCC: "",
            disabled: "",
            busNumber: "",
        },

        newTeacher: {
            teacherCode: "",
            teacherNameRecording: "",
            alertPhone: "",
            connectionMode: "",
            branch: [],
            pinNumber: "",
            alertTime: "",
            allowBroadcast: "",
            allowChargeCC: "",
            disabled: "",
            busNumber: "",
            name: "",
            nameH: "",
            type: "CONTACTS",
        },

        processing: false,
        uploading: false,
        deleteTeacherConfirmationDialog: false,
        deletingTeacher: false,
        files: [],
        types: [],
        url: "",
        regID: "",
        awsPolly: "",
        branchList: [],

        addNewTeacherDialog: false,

        rules: {
            required: (value) => !!value || "Required.",
            pinNumber: (v) => {
                return (
                    !v ||
                    ([5].includes(v.replace(/-/g, "").length) &&
                        /^\d+$/.test(v.replace(/-/g, ""))) ||
                    "Invalid Pin Number, Must be 5 digits"
                );
            },
            phoneNumber: (v) => {
                return (
                    !v ||
                    ([10, 11].includes(v.replace(/-/g, "").length) &&
                        /^\d+$/.test(v.replace(/-/g, ""))) ||
                    "Invalid Phone Number"
                );
            },
        },

        columns: [
            {
                label: "Teacher Code",
                field: "teacherCode",
                visible: true,
                link: "TeacherView",
                template: "link-cell-template",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher Hebrew",
                field: "teacherH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher",
                field: "teacher",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Recording",
                template: "link-audio-cell-template",
                field: "teacherNameRecording",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Class",
                field: "class",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Building",
                field: "building",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Alert Phone",
                field: "alertPhone",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Pin Number",
                field: "pinNumber",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Alert Time",
                field: "alertTime",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Type",
                field: "type",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus Number",
                field: "busNumber",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Connection Mode",
                field: "connectionMode",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Allow Broadcast",
                field: "allowBroadcast",
                visible: true,
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Disabled",
                field: "disabled",
                visible: true,
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Allow Charge CC",
                field: "allowChargeCC",
                visible: true,
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Call At",
                field: "lastCallAt",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Tip Balance",
                field: "tipBalance",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    async mounted() {
        const settings = await this.getAwsSettings();

        this.awsPolly = new AWS.Polly({
            accessKeyId: settings.accessKey,
            secretAccessKey: settings.secretKey,
            region: "us-east-1",
        });
    },
    beforeDestroy() {},
    async created() {
        this.updateTeacherSettings();

        this.loadBranches();
    },
    methods: {
        async getAwsSettings() {
            const response = await this.$http.get(
                "api/adminPortal/GetAwsPollyCredentials",
            );

            return response;
        },
        async beforeSetupGrid() {
            if (this.getBranch()) {
                this.userBranch = this.getBranch();

                this.addRestrictions();
            }

            // if (!this.userBranch || this.userBranch.includes("BUS")) {
            //     this.actions.push({
            //         text: "Add Bus Driver",
            //         action: this.addBusDriver,
            //     });
            // }

            // this.actions.push({
            //     text: "Add Contacts",
            //     action: this.addContacts,
            // });

            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms,
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.url =
                "teachers?branch=" +
                (this.userBranch ? this.userBranch : "") +
                "&grade=&regID=" +
                this.regID;
        },
        async loadBranches() {
            const branches = await this.$http.get("api/students/getBranchList");

            this.branchList = branches.sort();
            this.branchList.push("BUS");

            if (
                this.$store.state.authentication.branch &&
                !this.$store.state.authentication.branch.includes("null")
            ) {
                this.branchList = this.$store.state.authentication.branch.split(
                    ",",
                );
            }
        },
        addRestrictions() {
            this.columns = this.columns.filter(
                (c) =>
                    ![
                        "pinNumber",
                        "alertTime",
                        "connectionMode",
                        "allowBroadcast",
                        "disabled",
                        "allowChargeCC",
                        "lastCallAt",
                        "tipBalance",
                    ].includes(c.field),
            );

            this.columns.find((t) => t.field == "teacherCode").link = null;
            this.columns.find((t) => t.field == "teacherCode").template = null;
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/allStudents/getRegID");
        },
        async getTerms() {
            return await this.$http.get("api/allStudents/getRegTerms");
        },
        onTermSelected(value) {
            this.regID = value;

            this.url =
                "teachers?branch=" +
                (this.userBranch ? this.userBranch : "") +
                "&grade=&regID=" +
                this.regID;

            this.$refs.grid.reloadDataSource(this.url);
        },
        getBranch() {
            return this.$store.state.authentication.branch &&
                !this.$store.state.authentication.branch.includes("null")
                ? this.$store.state.authentication.branch
                : "";
        },
        isBusDriverBranch() {
            return this.userBranch.includes("BUS");
        },
        isContact() {
            return this.rowClicked.type == "CONTACTS";
        },
        isBusDriver() {
            return this.rowClicked.type == "BUS_DRIVER";
        },
        async saveNewTeacher() {
            if (
                !this.$refs.newName.validate(true) ||
                !this.$refs.newNameH.validate(true) ||
                !this.$refs.newAlertPhone.validate(true)
            )
                return;

            if (!this.newTeacher.branch.length) {
                return this.$notify({
                    text: "Please select branch",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                await this.$http.post("api/teachers/saveNewTeacher", {
                    phoneNumber: this.newTeacher.alertPhone
                        ? this.newTeacher.alertPhone.length == 11
                            ? this.newTeacher.alertPhone
                            : "1" + this.newTeacher.alertPhone
                        : "",
                    name: this.newTeacher.name,
                    nameH: this.newTeacher.nameH,
                    branch: this.newTeacher.branch.join(","),
                    busNumber: this.newTeacher.busNumber,
                    nameRecording: this.newTeacher.teacherNameRecording,
                    type: this.newTeacher.type,
                });

                this.processing = false;
                this.addNewTeacherDialog = false;

                this.newTeacher.teacherCode = "";
                this.newTeacher.teacherNameRecording = "";
                this.newTeacher.alertPhone = "";
                this.newTeacher.connectionMode = "";
                this.newTeacher.branch = [];
                this.newTeacher.pinNumber = "";
                this.newTeacher.alertTime = "";
                this.newTeacher.allowBroadcast = "";
                this.newTeacher.allowChargeCC = "";
                this.newTeacher.disabled = "";
                this.newTeacher.busNumber = "";
                this.newTeacher.name = "";
                this.newTeacher.nameH = "";
                this.newTeacher.type = "CONTACTS";

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        onRowClicked(row) {
            if (
                this.userBranch &&
                !this.userBranch.includes("BUS") &&
                row.type != "CONTACTS"
            ) {
                return this.$notify({
                    text: "Can't edit teacher",
                    group: "notification",
                    type: "error",
                });
            }

            this.rowClicked = JSON.parse(JSON.stringify(row));
            this.rowClicked.alertTime = this.rowClicked.alertTime
                ? moment(this.rowClicked.alertTime, "hh:mm A").format("HH:mm")
                : "";

            this.rowClicked.name = row.teacher;
            this.rowClicked.nameH = row.teacherH;
            this.rowClicked.teacherNameRecording = row.teacherNameRecording;

            this.updateTeacherDialog = true;
        },
        addBusDriver() {
            this.newTeacher.type = "BUS_DRIVER";
            this.newTeacher.branch = ["BUS"];

            this.addNewTeacherDialog = true;
        },
        addContacts() {
            this.newTeacher.type = "CONTACTS";

            this.addNewTeacherDialog = true;
        },
        async updateTeacherSettings() {
            await this.$http.post("api/teachers/updateTeacherSettings");

            return this.$notify({
                text: "Teacher Settings Updated",
                group: "notification",
                type: "success",
            });
        },
        pickFile(isNew = false) {
            if (isNew) {
                this.$refs.newTeacherFiles.click();
            } else {
                this.$refs.files.click();
            }
        },
        async onFilePicked(e, isNew = false) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            try {
                var formData = new FormData();

                formData.append("upload_file", files[0]);

                const url = await this.$http.post(
                    "api/schoolPhones/uploadFile?",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                if (isNew) {
                    this.newTeacher.teacherNameRecording = url;
                } else {
                    this.rowClicked.teacherNameRecording = url;
                }

                this.uploading = false;
            } catch (e) {
                this.uploading = false;
            }
        },
        saveAlertTime(value) {
            this.$refs.alertTime.save(value);
        },
        playText(text) {
            let params = {
                OutputFormat: "mp3",
                Text: text,
                TextType: "text",
                VoiceId: "Matthew",
            };

            this.awsPolly.synthesizeSpeech(params, (err, data) => {
                const uInt8Array = new Uint8Array(data.AudioStream);
                const arrayBuffer = uInt8Array.buffer;
                const blob = new Blob([arrayBuffer]);
                const url = URL.createObjectURL(blob);
                console.log(url);
                var audio = new Audio(url);
                audio.play();
            });
        },
        async save() {
            if (
                (this.$refs.pinNumber &&
                    !this.$refs.pinNumber.validate(true)) ||
                !this.$refs.alertPhone.validate(true)
            )
                return;

            try {
                this.processing = true;

                const data = JSON.parse(JSON.stringify(this.rowClicked));

                data.pinNumber = data.pinNumber
                    ? data.pinNumber.trim()
                    : data.pinNumber;
                data.alertPhone = data.alertPhone
                    ? data.alertPhone.replaceAll("-", "")
                    : data.alertPhone;
                data.alertPhone = data.alertPhone
                    ? data.alertPhone.length == 11
                        ? data.alertPhone
                        : "1" + data.alertPhone
                    : "";

                data.alertTime = data.alertTime
                    ? moment(data.alertTime, "h:mm").format("hh:mm A")
                    : null;

                await this.$http.post("api/teachers/save", data);

                this.updateTeacherDialog = false;
                this.processing = false;

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async deleteTeacher() {
            this.deletingTeacher = true;

            try {
                await this.$http.post(
                    "api/teachers/deleteTeacher?teacherCode=" +
                        this.rowClicked.teacherCode,
                );

                this.deleteTeacherConfirmationDialog = false;
                this.updateTeacherDialog = false;
                this.deletingTeacher = false;

                this.$refs.grid.reloadGrid();
            } catch (e) {
            } finally {
                this.deletingTeacher = false;
            }
        },
    },
};
</script>
<style>
.gray-fg {
    color: #999;
}
</style>
